module.exports = __webpack_public_path__ + "img/floor3_2.9f81ab13.png";